import { Box, Typography } from '@mui/material';
import { ExportDateTimePicker } from './ExportDateTimePicker';
import { ContainedButton, OutlinedButton } from '@shared/components';
import { DownloadIcon, SyncIcon } from '@sanity/icons';
import { useExportTFunction } from '@retail/export/i18n';

interface Props {
  toggleExportDialog?: () => void;
  onUpdateDateTimePicker: (fromDate: Date | null) => void;
  handleRecalculate?: () => void;
  isLoadingRecalculate: boolean;
  isLoadingDownload: boolean;
  noSelectedSupplierIds: boolean;
}

export const ExportButtons = ({
  onUpdateDateTimePicker,
  toggleExportDialog,
  handleRecalculate,
  isLoadingRecalculate,
  isLoadingDownload,
  noSelectedSupplierIds,
}: Props) => {
  const t = useExportTFunction();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="body2">{t('export.fromDate')}</Typography>

      <ExportDateTimePicker onUpdateDateTimePicker={onUpdateDateTimePicker} />
      {handleRecalculate && (
        <OutlinedButton
          size="small"
          color="secondary"
          startIcon={<SyncIcon />}
          onClick={handleRecalculate}
          loading={isLoadingRecalculate}
        >
          {t('export.recalculate')}
        </OutlinedButton>
      )}
      {toggleExportDialog && (
        <ContainedButton
          disabled={noSelectedSupplierIds}
          color="secondary"
          size="small"
          onClick={toggleExportDialog}
          loading={isLoadingDownload}
          startIcon={<DownloadIcon />}
        >
          {t('export.download')}
        </ContainedButton>
      )}
    </Box>
  );
};
